/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  if (typeof cart_cell_id !== 'string') {
    return;
  }

  var cartCell = jQuery(cart_cell_id);

  if (!cartCell.length) {
    return;
  }

  function escapeHtml(value) {
    return jQuery('<div>')
      .text(value == null ? '' : String(value))
      .html();
  }

  function escapeAttribute(value) {
    return escapeHtml(value)
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  cartCell.empty();

  if (cart.items && cart.items.length) {
    jQuery(
      '.cart-item-loop, .cart-item-title, .subtotal-title-area'
    ).css({
      display: 'block'
    });

    jQuery('.cart-empty-title').css({
      display: 'none'
    });

    jQuery.each(cart.items, function (i, item) {
      if (i > 19) {
        return false;
      }

      var propertiesHtml = '';

      if (item.properties) {
        jQuery.each(item.properties, function (propertyName, propertyValue) {
          if (
            propertyName.charAt(0) === '_' ||
            propertyValue === null ||
            propertyValue === ''
          ) {
            return;
          }

          propertiesHtml +=
            '<span class="item-option" style="margin-left: 0;">' +
              '<span class="pro-variant-title">' +
                escapeHtml(propertyName) +
                ':' +
              '</span> ' +
              '<span class="pro-variant-type">' +
                escapeHtml(propertyValue) +
              '</span>' +
            '</span>';
        });
      }

      var imageUrl = '';

      if (typeof item.image === 'string') {
        imageUrl = item.image;
      } else if (item.image && item.image.src) {
        imageUrl = item.image.src;
      }

      var itemKey = item.key || item.variant_id;

      var itemHtml =
        '<li class="cart-item">' +

          '<div class="cart-image">' +
            '<a href="' + escapeAttribute(item.url) + '">' +
              '<img' +
                ' src="' + escapeAttribute(imageUrl) + '"' +
                ' alt="' + escapeAttribute(item.alt || item.title) + '"' +
                ' width="100"' +
                ' height="100"' +
                ' class="img-fluid"' +
                ' loading="lazy"' +
              '>' +
            '</a>' +
          '</div>' +

          '<div class="cart-title">' +
            '<a href="' + escapeAttribute(item.url) + '">' +
              escapeHtml(item.title.substring(0, 50)) +
            '</a>' +

            propertiesHtml +

            '<div class="cart-pro-info">' +
              '<div class="cart-qty-price">' +
                '<span class="quantity-' +
                  escapeAttribute(item.id) +
                '">' +
                  escapeHtml(item.quantity) +
                '</span>' +

                ' × ' +

                '<span class="price-box">' +
                  '<span class="new-price">' +
                    Shopify.formatMoney(
                      item.price,
                      ""
                    ) +
                  '</span>' +
                '</span>' +
              '</div>' +

              '<div class="product-quantity-action">' +
                '<div class="product-quantity"' +
                  ' data-variant="' +
                  escapeAttribute(item.id) +
                '">' +
                  '<div class="cart-plus-minus">' +
                    '<div class="dec qtybutton">-</div>' +

                    '<input' +
                      ' value="' + escapeAttribute(item.quantity) + '"' +
                      ' type="text"' +
                      ' name="quantity"' +
                      ' min="1"' +
                      ' pattern="[0-9]*"' +
                    '>' +

                    '<div class="inc qtybutton">+</div>' +
                  '</div>' +
                '</div>' +

                '<div class="delete-item-cart">' +
                  '<a' +
                    ' class="remove_from_cart"' +
                    ' href="javascript:void(0);"' +
                    ' data-item-key="' +
                    escapeAttribute(itemKey) +
                  '">' +
                    '<i class="feather-trash-2"></i>' +
                  '</a>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>';

      jQuery(itemHtml).appendTo(cartCell);
    });

    cartCell
      .find('.remove_from_cart')
      .off('click.cartUpdateInfo')
      .on('click.cartUpdateInfo', function (event) {
        event.preventDefault();

        var itemKey = jQuery(this).attr('data-item-key');
        Shopify.removeItem(itemKey);
      });
  } else {
    jQuery(
      '.cart-item-loop, .cart-item-title, .subtotal-title-area'
    ).css({
      display: 'none'
    });

    jQuery('.cart-empty-title').css({
      display: 'block'
    });
  }

  jQuery('.subtotal-price').html(
    Shopify.formatMoney(
      cart.total_price,
      ""
    )
  );

  jQuery('.bigcounter').html(cart.item_count);

  jQuery('.currency .active').trigger('click');
};

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};